<style>
.enk_order {

}
</style>

<script>
    import { trackArray, mutations, actions} from '../mainStore.js';
    import { onMount } from 'svelte';

    export let orderId

    let order

    onMount(async () => {
        order = await actions.getOrder(orderId)
        mutations.setOrder({
            id: order.id,
            bitrix_id: order.order_bitrix_id,
            userEmail: order.email,
            userPhone: order.phone,
            userName: order.name,
            userComment: order.comment,
            count: order.count,
        })
        mutations.setFirst(true);
        let track = $trackArray.find(r => r.id == order.track_id)
        if (track) {
            mutations.setTrack(track)
            mutations.setColorTrack(order.track_color_code, track.color_list[order.track_color_code])
            await actions.getItems(track.id)
            mutations.addItemsAuto(order.items)
            mutations.setStep(2)
        }
    })
</script>

<div class="enk_order">
    Загрузка деталей заказа
</div>
